<template>
  <basicLayout>
    <v-card>
      <v-list two-line subheader>
        <div v-for="project in projects" :key="project.id">
          <v-subheader style="background-color: antiquewhite">Projekt: {{ project.name }}</v-subheader>
          <v-list-tile v-for="delivery in project.deliveries" :key="delivery.deliveryNr" :to="`/delivery/${delivery.operation.id}/${delivery.deliveryNr}`">
            <v-list-tile-content>
              <v-list-tile-title>
                {{ delivery.deliveryNr }}
                <span class="gray ml10">{{ delivery.countArticles }} Artikel</span>
              </v-list-tile-title>
              <v-list-tile-sub-title>Für den Einsatz am {{ format(delivery.operation.date, 'DD.M.') }} in {{ delivery.operation.city }}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn icon ripple>
                <v-icon color="grey lighten-1">keyboard_arrow_right</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile v-if="project.deliveries.length === 0">
            <v-list-tile-content>
              <v-list-tile-title class="gray">
                Keine Lieferungen in diesem Projekt
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </div>
      </v-list>
    </v-card>
  </basicLayout>
</template>

<script>
/* eslint-disable */
import basicLayout from '@/layouts/basicLayout'
import { mapGetters } from 'vuex'
import { format } from 'date-fns'

export default {
  components: { basicLayout },
  data: () => ({
    format
  }),
  mounted() {
    this.$store.dispatch('getProjects');
  },
  computed: {
    ...mapGetters(['projects']),
  },
  methods: {},
}
</script>

<style scoped lang="scss">

</style>
